import { Component, Input, OnInit, OnDestroy, ViewChild } from "@angular/core";

import {
  ManifestService,
  Manifest,
  ViewService,
  ConfigService,
  PeopleService,
  FacilityService,
  GeneratorService,
  TransporterService,
  Facility,
  Transporter,
  Generator,
  Container,
  ContainerService,
} from "../../common";
import { ActivatedRoute, NavigationExtras, Router } from "@angular/router";
import { NgForm } from "@angular/forms";

@Component({
  templateUrl: "./manifest-property-editor-view.html",
  styleUrls: ["./manifest-property-editor-view.css"],
  standalone: false,
})
export class ManifestPropertyEditorView implements OnInit, OnDestroy {
  typeOptions: string[];
  public wasteTypeOptions: string[];
  public facilities: Facility[];
  public transporters: Transporter[];
  public generators: Generator[];
  subscriptions: any[];
  errorMsg: string;
  containers: Container[];

  gettingSaveCursor: any;
  trackingNumber: string;

  @ViewChild(NgForm) form;
  @Input() manifest: Manifest;

  constructor(
    private router: Router,
    public viewService: ViewService,
    public manifestService: ManifestService,
    public containerService: ContainerService,
    public peopleService: PeopleService,
    private configService: ConfigService,
    private generatorService: GeneratorService,
    private transporterService: TransporterService,
    private facilityService: FacilityService,
    private route: ActivatedRoute
  ) {
    this.subscriptions = [];

    viewService.setViewData({ pageTitle: "Manifest Editor" });
  }

  reset() {
    this.manifest = null;
    setTimeout(() => {
      this.manifest = new Manifest();
      this.manifest.totalPages = 0;
      this.setGenerator(this.generators[0]);
    });
  }

  setFacility(facility: Facility) {
    this.manifest.facilityName = facility.facilityName;
    this.manifest.facilityEpaid = facility.epaid;
    this.manifest.facilityPhone = facility.phone;
    this.manifest.facilityAddress = facility.address;
  }

  setTransporter1(transporter: Transporter) {
    this.manifest.transporter1Company = transporter.company;
    this.manifest.transporter1Epaid = transporter.epaid;
  }

  setTransporter2(transporter: Transporter) {
    this.manifest.transporter2Company = transporter.company;
    this.manifest.transporter2Epaid = transporter.epaid;
  }

  setGenerator(generator: Generator) {
    this.manifest.generatorCompany = generator.company;
    this.manifest.generatorMailingAddress = generator.mailingAddress;
    this.manifest.generatorName = generator.name;
    this.manifest.generatorId = generator.id.toString();
    this.manifest.generatorPhone = generator.phone;
    this.manifest.emergencyPhone = generator.emergencyPhone;
  }

  printPage() {
    window.print();
  }

  hInstPageNo(i: number) {
    return Math.floor((i + 6) / 10) + 1;
  }
  showHS(i: number) {
    return (
      i % 10 === 3 ||
      (this.manifest.containers.length > 0 &&
        i % 10 !== 3 &&
        i + 1 === this.manifest.containers.length)
    );
  }
  save() {
    this.manifestService.save(this.manifest).subscribe(
      (man) => {
        this.errorMsg = null;
        if (this.manifest.isNew) {
          this.router.navigate([`manifests/${man.trackingNumber}/edit`]);
        }
      },
      (error) => (this.errorMsg = error)
    );
  }

  ngOnInit() {
    this.configService.get().subscribe((appConfig) => {
      this.wasteTypeOptions = appConfig.wasteTypeOptions;
    });

    this.transporterService.getActive().subscribe((transporters) => {
      this.transporters = transporters.data;
    });
    this.facilityService.getActive().subscribe((facilities) => {
      this.facilities = facilities.data;
    });

    this.subscriptions.push(
      this.route.params.subscribe((params) => {
        let manifestId = params["manifestId"];
        this.generatorService.getActive().subscribe((generators) => {
          this.generators = generators.data;
          if (manifestId) {
            this.trackingNumber = manifestId;
            this.manifestService.get(manifestId).subscribe((manifest) => {
              if (!manifest.canEdit) {
                this.viewService.back();
              } else {
                this.manifest = manifest;
                this.containerService
                  .filterByManifest(this.trackingNumber)
                  .subscribe((response) => {
                    this.containers = response;
                  });

                this.viewService.setViewData({
                  pageTitle: `Modifying ${manifest.trackingNumber}`,
                });
              }
            });
          } else {
            this.reset();
            setTimeout(() => {
              this.viewService.setViewData({ pageTitle: `Creating a new Manifest` });
            });
          }
        });
      })
    );
  }

  remove(id: number) {
    this.manifestService.remove(id).subscribe(
      () => {
        this.viewService.back();
      },
      (error) => (this.errorMsg = error)
    );
  }

  navigateToAddContainer() {
    const navigationExtras: NavigationExtras = {
      state: {
        trackingNumber: this.trackingNumber,
        type: this.manifest.wasteType,
      },
    };
    this.router.navigate(["containers/new"], navigationExtras);
  }

  ngOnDestroy() {
    this.subscriptions.forEach((x) => x.unsubscribe());
  }
}
